document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-dd-lucky-drop]").forEach((drop) => {
    if (drop.dataset.ddLuckyDropBound === "true") return;

    const toggle = drop.querySelector("[data-dd-lucky-drop-toggle]");
    const close = drop.querySelector("[data-dd-lucky-drop-close]");
    const panel = drop.querySelector(".dd-lucky-drop__panel");

    if (!toggle || !close || !panel) return;

    drop.dataset.ddLuckyDropBound = "true";

    const setOpen = (isOpen) => {
      drop.classList.toggle("is-open", isOpen);
      toggle.setAttribute("aria-expanded", String(isOpen));
      panel.setAttribute("aria-hidden", String(!isOpen));
    };

    toggle.addEventListener("click", () => {
      setOpen(!drop.classList.contains("is-open"));
    });

    close.addEventListener("click", () => {
      setOpen(false);
      toggle.focus();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && drop.classList.contains("is-open")) {
        setOpen(false);
        toggle.focus();
      }
    });
  });
});
